import groq from 'groq'
import { ButtonQuery } from '../atoms/ButtonQuery'

export const PageTitleQuery = groq`
    _type == "PageTitle" => {
        ...,
        ${ButtonQuery},
        image {
            ...,
            asset->{
                ...,
                _id,
                url,
                _type,
                altText,
                description,
                title,
                metadata {
                    blurHash,
                    dimensions,
                }
            }
        },    
    }
`
